/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Availability_Page_TitleInputs */

const en_booking_availability_page_title = /** @type {(inputs: Booking_Availability_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability`)
};

const pl_booking_availability_page_title = /** @type {(inputs: Booking_Availability_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostępność`)
};

/**
* | output |
* | --- |
* | "Availability" |
*
* @param {Booking_Availability_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_availability_page_title = /** @type {((inputs?: Booking_Availability_Page_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Availability_Page_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_availability_page_title(inputs)
	return en_booking_availability_page_title(inputs)
});